import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2900d099"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["width", "height", "fill"]


export default /*#__PURE__*/_defineComponent({
  props: {
  value: {
    type: Number,
  },
  width: {
    type: Number,
  },
  height: {
    type: Number,
  },
  fill: {
    type: String,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("rect", {
      width: __props.width,
      height: __props.height,
      fill: __props.fill
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})